import { Button } from 'components/atoms';
import { Form } from 'components/organisms';
import { FormikHelpers } from 'formik';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { PiX } from 'react-icons/pi';
import { useNavigate } from 'react-router-dom';
import { usePostSectionTemplate } from 'services/templates/section-template';
import { IContractTemplateForm } from 'services/templates/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { contractTemplateUtil } from 'utils';
import { onErrorShowAllErrorsToast } from 'utils/service/errorHandler';

const CreateCustomSectionTemplate = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const createSection = usePostSectionTemplate();

  const goBackToContractTemplate = () => navigate('/templates-extended');

  const onCreateSectionTemplate = async (
    values: IContractTemplateForm,
    formikHelpers: FormikHelpers<IContractTemplateForm>
  ) => {
    await createSection.mutateAsync(
      {
        customSectionTemplate: middleware.template.section.formToQuery(values),
      },
      {
        onSuccess: id => navigate(`/templates-extended/section/${id}/form`),
        onError: error => onErrorShowAllErrorsToast(error),
      }
    );
  };

  return (
    <Form.Contract
      tittle={t('contract-template.section.title')}
      customBackItem={
        <Button type='button' onlyIcon onClick={goBackToContractTemplate}>
          <Button.Description description={t('button.cancel')} />

          <Button.Icon icon={<PiX />} />
        </Button>
      }
      topbarContent={
        <>
          <Button type='submit' variant={BUTTON_VARIANT.submit}>
            <Button.Text text={t(`button.create`)} />
          </Button>
        </>
      }
      initialStatus={contractTemplateUtil.section.initialStatus}
      initialValues={{
        ...contractTemplateUtil.form.initialValues,
        items: contractTemplateUtil.section.initialValues(),
      }}
      onSubmit={onCreateSectionTemplate}
    />
  );
};

export default CreateCustomSectionTemplate;
